import { z } from "zod";

const additionalPropertiesSchema = z.object({
  psClickId: z.string().nullable(),
  psPartnerKey: z.string().nullable(),
  referralId: z.string().nullable(),
  utmSource: z.string().nullable(),
  utmMedium: z.string().nullable(),
  utmCampaign: z.string().nullable(),
});

export const formContextSchema = z.object({
  hubspotutk: z.string().nullable(),
  pageURI: z.string(),
  pageName: z.string(),
  additionalProperties: additionalPropertiesSchema,
});

export type FormContext = z.infer<typeof formContextSchema>;
